<template>
  <fragment>
    <v-container fluid class="mx-1 my-16">
      <v-row>
        <v-col cols="1" class="ma-0 pa-0" dense>
          <v-btn
            icon
            absolute
            top
            left
            @click="returnHome"
            class="base ml-1 mt-7"
          >
            <v-icon color="black">mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="10" class="pa-0" :class="{ 'ml-n16': mdAndUp }">
          <v-card-title
            class="mt-n11 mb-8 pl-4"
            :class="{ 'mt-n7 mb-10 title-style-mobile': !mdAndUp }"
            :style="{
              'word-break': !mdAndUp ? 'break-word' : 'break-all',
            }"
          >
            <div text class="event-title-desk" absolute>
              <span
                class="text-h5"
                :class="{
                  'text-subtitle-1 mb-n3': !mdAndUp,
                }"
                style="max-width: 1200px"
              >
                Evento - {{ dashEvent.descricao }}
              </span>
            </div>
          </v-card-title>
        </v-col>
      </v-row>

      <v-card-text class="mt-n16 pa-2" align="start">
        <v-row>
          <v-col cols="12" md="9">
            <DashInfoModal />
          </v-col>
          <v-col cols="12" sm="2" md="3">
            <v-sheet
              class="pa-3"
              v-if="dashEventLoading"
              style="min-height: 50; height: 100%; width: 100%"
            >
              <v-skeleton-loader
                type="card"
                class="rounded-xl"
                style="min-height: 50; height: 100%; width: 100%"
              >
              </v-skeleton-loader>
            </v-sheet>
            <DashCardCheckin
              v-else
              title="Check-in"
              :loading="dashEventLoading"
              :percent="percentCheckin"
              :percentcheck="percentCheck"
            >
            </DashCardCheckin>
          </v-col>
        </v-row>
        <ReportDash :headers="headers" />
        <v-row class="mt-n3">
          <EventSlider />
        </v-row>
      </v-card-text>
      <!-- </v-card> -->
    </v-container>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";
import DashInfoModal from "@/components/cards/DashInfoModal.vue";
import EventSlider from "@/components/cards/EventSlider.vue";
import DashCardCheckin from "@/components/cards/DashCardCheckin.vue";
import ReportDash from "@/components/cards/report/ReportDash.vue";
import ResumeCard from "@/components/cards/ResumeCard.vue";
export default {
  name: "Resume",
  mixins: [displayHelpers],
  components: {
    DashInfoModal,
    // eslint-disable-next-line vue/no-unused-components
    EventSlider,
    DashCardCheckin,
    ReportDash,
    // eslint-disable-next-line vue/no-unused-components
    ResumeCard,
  },
  props: {
    isOpenModal: Boolean,
  },
  data() {
    return {
      expand: false,
      headers: [
        {
          text: "Data da Venda",
          align: "center",
          width: 150,
        },
        {
          text: "Quant. de Pedidos",
          align: "center",
          width: 200,
        },
        {
          text: "Quant. de Itens",
          align: "center",
          width: 200,
        },
        {
          text: "Valor",
          align: "center",
          width: 150,
        },
        {
          text: "Juros",
          align: "center",
          width: 130,
        },
        {
          text: "Descontos",
          align: "center",
          width: 200,
        },
        {
          text: "Total",
          align: "center",
          width: 120,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "storeList",
      "storeSequencial",
      "dashEvent",
      "dashEventLoading",
      "dashEventHasData",
      "checkinEvent",
      "saleTicket",
    ]),
    percentCheckin() {
      if (Math.sign(this.checkinEvent.percentual_realizados) >= 1) {
        return {
          text: "Realizados",
          value: Math.round(this.checkinEvent.percentual_realizados) + "%",
          class: "positive-percent",
        };
      } else {
        return {
          text: "Realizados",
          value: "0%",
          class: "positive-percent",
        };
      }
    },
    percentCheck() {
      if (Math.sign(this.checkinEvent.percentual_restantes) >= 1) {
        return {
          text: "Restantes",
          value: Math.round(this.checkinEvent.percentual_restantes) + "%",
          class: "positive-percent",
        };
      } else {
        return {
          text: "Restantes",
          value: "100%",
          class: "positive-percent",
        };
      }
    },
    activeEvents() {
      let events = [...this.$dashboard.eventosAtivos];
      return events;
    },
    inactiveEvents() {
      let events = [...this.$dashboard.eventosEncerrados];
      return events;
    },
  },
  methods: {
    ...mapActions(["setDashEvent"]),
    getStorage() {
      const storage = JSON.parse(localStorage.getItem("evento"));
      return this.setDashEvent(storage);
    },
    returnHome() {
      this.$router.go(-1);
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin") {
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (this.isAdmin) {
      this.$dashboard.getEventos("load", 10, this.storeSequencial);
    } else {
      this.$dashboard.getEventos("load", 10);
    }
    this.getStorage();
  },
};
</script>
<style scoped>
.event-image {
  position: relative;
}
.event-image::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(6px) brightness(0.8);
}

.event-title {
  font-family: "Roboto", sans-serif;
  font-size: 2.3rem !important;
  font-weight: 800;
  letter-spacing: 0.0068em !important;
  margin-bottom: 20px;
  color: white;
  white-space: pre;
  backdrop-filter: blur(0px);
  margin-left: -8% !important;
}
.event-title-desk {
  font-family: "Roboto", sans-serif;
  font-size: 0.875rem !important;
  font-weight: 800;
  letter-spacing: 0.0068em !important;
  margin-bottom: 20px;
  /* color: black; */
  /* margin-left: -100px !important; */
}

@media screen and (max-width: 600px) {
  .event-title {
    font-family: "Roboto", sans-serif;
    font-size: 1.2rem !important;
    font-weight: 800;
    letter-spacing: 0.0048em !important;
    margin-top: 100px !important;
    color: white;
    margin-left: -14px;
    backdrop-filter: blur(0px);
  }
}
</style>
